// /chatbot de configuración. Solo superadmin; el cliente vuelve al inicio.
// El superadmin cae en Configuración, pestaña Chatbot.

import { createFileRoute, redirect } from '@tanstack/react-router';
import { configRouteRedirect } from '~/lib/config-access';
import { currentUser } from '~/lib/pb';

export const Route = createFileRoute('/_authed/chatbot')({
  beforeLoad: () => {
    const dest = configRouteRedirect(currentUser()?.role, '/chatbot');
    if (dest) throw redirect(dest);
    throw redirect({
      to: '/settings',
      search: { tab: 'chatbot' },
    });
  },
});
